import { render, staticRenderFns } from "./recs.vue?vue&type=template&id=2e0bff90&scoped=true&"
import script from "./recs.vue?vue&type=script&lang=js&"
export * from "./recs.vue?vue&type=script&lang=js&"
import style0 from "./recs.vue?vue&type=style&index=0&id=2e0bff90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0bff90",
  null
  
)

export default component.exports